import { render } from "./SecurityNumber.vue?vue&type=template&id=0ab26954"
import script from "./SecurityNumber.vue?vue&type=script&lang=js"
export * from "./SecurityNumber.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__